import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal';
import { useLanguage } from '../context/LanguageContext';
import { croppedServiceImages, serviceImages } from '../content/serviceImages';

function ServicesPage() {
  const { t } = useLanguage();
  const groups = t.servicesCatalog?.groups || [];
  const sovereign = t.servicesCatalog?.sovereign;
  const services = [...groups.flatMap((group) => group.items), ...(sovereign ? [sovereign] : [])];

  return (
    <main className="inner-page">
      <section className="container page-hero">
        <Reveal>
          <span className="eyebrow services-hero-eyebrow">{t.servicesPage.eyebrow}</span>
          <h1>{t.servicesPage.title}</h1>
          <p>{t.servicesPage.subtitle}</p>
        </Reveal>
      </section>

      <section className="container service-catalog">
        {services.map((service, idx) => {
          const reverse = idx % 2 === 1;
          const image = service.image || serviceImages[idx] || serviceImages[0];
          return (
            <article
              key={`${service.id}-${service.name}`}
              className={`service-z-row ${reverse ? 'service-z-row-reverse' : ''}`}
            >
              <Reveal direction={reverse ? 'right' : 'left'}>
                <div className="service-z-content">
                  <div className="service-z-meta">
                    <span className="service-catalog-number">{service.id}</span>
                  </div>
                  <h3>{service.name}</h3>
                  <h4>{service.platformTitle}</h4>
                  <p>{service.marketing}</p>
                  <Link to={`/services/${service.id}`} className="sd-know-more-btn">
                    {t.serviceDetail?.knowMore || 'Learn more'}
                    <span className="material-symbols-outlined" aria-hidden="true">arrow_forward</span>
                  </Link>
                </div>
              </Reveal>
              <Reveal direction={reverse ? 'left' : 'right'}>
                <div
                  className={`service-z-image ${croppedServiceImages.has(image) ? 'service-z-image-crop' : ''}`}
                  style={{ backgroundImage: `url(${image})` }}
                  role="img"
                  aria-label={service.name}
                />
              </Reveal>
            </article>
          );
        })}
      </section>
    </main>
  );
}

export default ServicesPage;
